export interface EditModeSlice {
    editMode: boolean;
    setEditMode: (value: boolean) => void;
    toggleEditMode: () => void;
}

export const createEditModeSlice = (set: any): EditModeSlice => ({
    editMode: false,
    setEditMode: (value: boolean) => set({ editMode: value }),
    toggleEditMode: () =>
        set((state: EditModeSlice) => ({ editMode: !state.editMode })),
});
